export const USER_LOGIN_URL = "auth/login";
export const USER_LOGOUT_URL = "auth/logout";
export const RESET_PASSWORD = "/auth/reset-password";
export const CHNAGE_PASSWORD = "/auth/user-change-password";
export const FORGOT_PASSWORD = `/auth/user-forgotpassword`;
export const OTP_VERIFY = `/auth/user-otp`;
export const UPDATE_USER_LOCATION = "/user/users/update-user-location";
export const SET_PASSWORD = `/auth/user-set-password`;
export const USER_SUB_DETAIL = `user/users/get-user-details`;
export const MEMBER_SUBSCRIPTION_EXPIRED_CHECK = `premium/subscriber-privileges/member-subscription-expired-check`;
export const GET_SYSTEM_SETTINGS = `/settings/settings/get-settings`;
export const UPDATE_SYSTEM_SETTINGS = `/settings/settings/create-or-update-settings`;
// mobimytravel sso
export const UPDATE_USER_ON_MOBIMYTRAVEL =
  "/settings/mobi-my-travel-sso/create-sso-url";
// ll url
export const GENERATE_LL_URL = "/user/users/ll-link-generate";

export const COMBINED_CLUB_URL = "/club/all-club/get-all-combined-clubs";

export const COUNTRY_LIST_URL = "db_handler/country/get-country-list";
export const BANNER_LIST_URL =
  "club/banner-images/get-banner-image-or-video-list";
export const RECIPROCAL_CLUB_LIST_URL =
  "club/reciprocal-club/member-reciprocal-club-list";
export const CLUB_FACILITY_CATEGORY_LIST_URL =
  "settings/facility-category/get-facility-category-list";
export const BESPOKE_LIST_URL = "event/events/club-events-list";
export const SPOT_LIGHT_LIST_URL = "club/all-club/get-club-spotlight";
export const TESTIMONIAL_LIST_URL = "settings/testimonial/get-testimonial-list";
export const UPCOMING_BOOKING_LIST_URL = "club/booking/get-upcoming-booking";
export const CONNECTED_CLUB_LIST =
  "/club/connected-club/get-list-connected-club";

export const GLOBAL_CLUB_LIST_URL =
  "club/all-club/get-global-club-network-list";
export const CLUB_FAVORITE_CHANGE_URL =
  "club/favourite-clubs/create-or-update-favourite-clubs";
export const CLUB_DETAIL_URL = "club/club-profile/get-club-profile-details";
export const FACILITY_DETAIL_URL =
  "club/club-facility/get-club-facility-details";
export const USER_DETAIL_URL = "club/member-profile/get-member-profile-details";
export const UPDATE_USER_DETAIL_URL =
  "club/member-profile/create-or-update-member-profile";
export const USER_PROFILE_DETAILS =
  "/club/member-profile/get-member-profile-details";

export const COUNTRY_DROPDOWN_URL = "db_handler/country/get-country-dropdown";
export const CITY_DROPDOWN_URL = "settings/city/get-city-dropdown";

export const CREATE_USER_CARD_URL =
  "club/member-card/create-or-update-member-card";
export const MEMBER_CARD_LIST_URL = "club/member-card/get-member-card-list";

export const MEMBER_FAVORITES_LIST_URL =
  "club/favourite-clubs/get-favourite-clubs-list";
// Activate
export const USER_ACTIVATE_URL =
  "user/userenquiry/create-or-update-user-enquiry";
export const USER_PROFILE_VISIBLITY_URL =
  "club/member-profile/member-visibility-status-change";

//Booking
export const USER_BOOKING_LIST_UTL = "club/booking/get-user-booking-list";
export const BOOKING_DETAIL_URL = "club/booking/get-club-booking-detail";
export const CREATE_CLUB_BOOKING_URL = "club/club-profile/club-booking";
export const CANCEL_BOOKING_URL = "club/booking/club-booking-cancel";
export const MODIFY_MEMBER_HOST_BOOKING =
  "club/member-profile/member-modified-host-booking";
export const PAYMENT_COMPLETED = "club/booking/booking-payment-complete-status";
export const PAYMENT_LINK_CLICKED =
  "/club/booking/booking-payment-link-clicked";

// host booking
export const GET_HOST_BOOKING_MEMBER =
  "/club/member-profile/list-host-bookings-member";
export const HOST_BOOKING_MEMBER_ACCEPT =
  "/club/member-profile/host-bookings-member-accept";
export const HOST_MEMBER_BOOKING_DECLINE =
  "/club/member-profile/host-bookings-member-decline";
export const HOST_MEMBER_BOOKING_MODIFY =
  "/club/member-profile/host-bookings-member-modify";
export const HOST_BOOKING_MEMBER_DECLINE =
  "/club/member-profile/host-bookings-member-decline";
export const HOST_BOOKING_MEMBER_ACCEPT_V1 =
  "/club/host-booking/host-accept-host-booking-member-modify";
export const HOST_DECLINE =
  "/club/member-profile/host-decline-modified-host-booking";
// Near me
export const NEAR_ME_URL = "club/all-club/get-nearme-clubs";

// memeber club
export const MEMBER_CLUB_URL = "club/booking/get-member-clubs";

//bespoke
export const BESPOKE_DETAIL_URL = "event/events/club-events-detail";

// EventEnquiry Url
export const EVENT_ENQUIRY_URL =
  "event/eventsenquiry/create-or-update-event-enquiry";

// connections

export const USER_CONNECTION_URL =
  "connections/connections/user-connection-list";
export const USER_CONNECTION_CHAT_URL =
  "connections/connections/user-chat-group-list";
export const SEND_REQUEST_CONNECTON_URL =
  "connections/connections/send-request-list";
export const SEND_REQUEST_DETAIL_CONNECTION_URL =
  "connections/connections/send-request-list";
export const INVITE_LIST_CONNECTION_URL =
  "connections/connections/invitation-list";
export const INVITE_DETAIL_CONNECTION_URL =
  "connections/connections/invitation-request-detail";
export const CHAT_CONNECTION_URL = "connections/connections/chat-messages-list";
export const GROUP_CHAT_CONNECTION_URL =
  "connections/groups/group-message-list";
export const CREATE_CHAT_URL = "connections/connections/create-chat";
export const SUBSCRIPTION_LIST_URL =
  "premium/subscriber-privileges/get-subscriber-privileges-list";
export const SUBSCRIPTION_DETAIL_URL =
  "premium/subscriber-privileges/get-subscriber-privileges-detail";
export const BOOKING_DETAIL = "club/booking/get-club-booking-detail";
export const CREATE_MEMBER_REVIEW_URL =
  "club/member-review/create-or-update-member-review";

export const SUBSCRIPTION_PRIVILAGE_LIST = `/premium/user-subscription/get-user-subscription-list`;

export const SUBSCRIPTION_NEW = `/premium/user-subscription/subscription-renewal-status-change`;

export const FCMTOKEN = `/user/users/update-user-fcm-token`;
export const NOTIFICATION_LIST = `/settings/notification/get-user-notification-list`;
export const READ_NOTIFICATION = `/settings/notification/read-user-notification`;
export const UNREADNOTIFICATION = `/settings/notification/unread-read-notification-count`;

export const CONNECTION_REQUEST_LIST_URL =
  "connections/connections/invitation-list";
export const CONNECTION_SEND_LIST_URL =
  "connections/connections/send-request-list";
export const CONNECTION_SEND_DETAIL_URL =
  "connections/connections/send-request-detail";

export const CREATE_GROUP_URL = "connections/groups/create-or-update-group";
export const DELETE_GROUP_URL = "connections/groups/admin-delete-group";
export const LEFT_GROUP_URL = "connections/groups/user-exit-group";
export const UPDATE_USER_EVENT_CATEGORY =
  "settings/global-event-category/user-add-global-event-category";
export const UPDATE_USER_FACILITY =
  "settings/user-facility-selection/create-or-update-user-facility-selection";
export const ADD_MEMBER_TO_GROUP = "connections/groups/add-user-to-group";
export const REMOVE_MEMBER_FROM_GROUP =
  "connections/groups/admin-remove-group-user";
export const SEND_SKIP_MAIL = "premium/user-subscription/skip-email";

export const GLOBAL_SEARCH = `/club/global-seach/search`;
export const GLOBAL_SEARCH_TRENDING = `/club/all-club/get-trending-search-list`;
export const USER_CONNECTION_DETAILS_URL = `connections/connections/suggested-user-details`;

export const COUNTRY_CLUB = `/club/all-club/get-country-club-list`;
export const FACILITY_CATEGORY = `/settings/facility-category/get-facility-category-dropdown`;
export const CLUB_TYPE = `/settings/clubtype/get-clubtype-dropdown`;
export const MEMBER_INTREST_LIST_URL = `/club/member-profile/member-interests-list`;
export const UPDATE_MEMBER_INTREST_URL = `/club/member-profile/add-member-interests`;
export const USER_SUGGESTION_LISTING_URL = `/connections/suggestions/user-suggestions`;

export const SUGGESTION = `/connections/suggestions/user-suggestions`;

// stripe payement intent

export const STRIPE_PAYEMENT =
  "premium/subscriber-privileges/stripe-payment-intent";
export const GLOBAL_EVENTS_INTREST_COUNT_URL =
  "event/globalevent/global-event-interest-count";
export const GLOBAL_EVENTS_INTREST_COUNT_POST_URL =
  "event/globalevent/create-or-update-global-event-interest";

export const ACTIVATES_LIST = "club/all-club/get-activity-club-list";

export const WITHDRAW_CONNECTION_URL =
  "connections/connections/withdraw-connection-request";
export const SEND_CONNECTION_URL =
  "connections/connections/send-connection-request";
export const CROSS_CONNECTION_URL =
  "connections/connections/cross-suggested-user";
export const ACCEPT_CONNECTION_URL =
  "connections/connections/accept-connection-request";
export const DECLINE_CONNECTION_URL =
  "connections/connections/decline-connection-request";
export const DND_CONNECTION_URL =
  "connections/connections/do-not-disturb-connection";

// Solatrie-club

export const SOLITARIE_CLUB_URL = "club/all-club/get-solitaire-clubs";

// card
export const MEMBER_CARD_DETAILS_URL =
  "club/member-card/get-member-card-details";
export const MEMBER_CARD_DELETE_URL = "club/member-card/delete-member-card";

// BookinG Acept and reject
export const BOOKING_MODIFY_ACCEPT = "club/booking/member-booking-accept";
export const BOOKING_MODIFY_REJCET = "club/booking/member-booking-decline";

export const GROUP_DETAILS_URL = `/connections/groups/get-group-details`;
export const EVENT_CATEGORY_LIST = `/settings/global-event-category/get-global-event-category-list`;
export const FACITLTY_CATEGORY_INTREST_LIST = `/settings/user-facility-selection/get-user-facility-selection`;

export const CARD_TOKENZATION_URL =
  "premium/subscriber-privileges/stripe-tokenisation";
export const SUBSCRIPTION_UPDATE_URL =
  "premium/subscriber-privileges/update-user-subscription-status";
export const SUBSCRIPTION_RENEWAL_UPDATE_URL =
  "user/users/user-90-renewal-update";
export const HOST_BOOKING_MEMBER =
  "/club/member-profile/enable-or-disable-host-booking-member";

// booking-message

export const BOOKING_MESSAGE_URL = "club/booking/member-send-messages";
export const BOOKING_MESSAGE_LIST_URL = "club/booking/member-messages-list";
export const BOOKING_LOI_SEND_URL = "club/booking/member-send-loi";

export const CARD_LIST_URL = "premium/card-details/get-card-details-list";
export const CARD_DELETE_URL = "premium/card-details/delete-card-details";

export const STRIPE_CHECKOUT = "premium/card-details/stripe-checkout";
export const CHOOSE_CARD = "premium/card-details/user-default-card";
export const USER_CONNECT_STATUS = "user/users/user-inchat-status-change";

export const USER_DETAIL_FROM_TOKEN = "auth/token-login";

// near club

export const NEAR_CLUB_URL = "/club/all-club/get-exclude-clubs";

// Spouse Offer
export const GET_SPOUSE_INVITE_PLAN =
  "/premium/spouse-invite/get-spouse-invite-plan-detail";
export const ADD_INVITE_SPOUSE_USER =
  "/premium/spouse-invite/invite-spouse-user";
export const GET_INVITE_SPOUSE_USER_LIST =
  "/premium/spouse-invite/spouse-user-invite-list";

export const UNSUBSCIBED_EMAIL = "/club/member-profile/member-email-unsubscribe";
export const LOCATION_LIST = "/settings/settings/retieve-unavailable-locations";
